import { Box, Button, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import {
  getTanClientEchallan,
  getIncomeTaxProfile,
  exportTanClientChallan,
  getTanClientsCredentials,
} from "api/services/automation/income-tax-tan";
import Table, { ColumnType } from "components/Table";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { StyledSpan } from "../../styles";
import { useState } from "react";
import AccessDenied from "../../Access/accessDenide";
import Loader from "components/Loader";
import { formatToRupeess } from "utils/formattedAmount";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import moment from "moment";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { handleError } from "utils/handleError";
import { snack } from "components/toast";
import { getCurrentFormattedDateTime } from "utils";
import { Height } from "@mui/icons-material";
import { getAutFinancialYears, sortFilter } from "pages/atom-pro/Tan/constants";
import SearchContainer from "components/SearchContainer";
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";

const TanClientChallan = (state) => {
  const params = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [checkAccess, setCheckAccess] = useState(true);
  const [assessmentYear, setAssessmentYear] = useState<any>(null);
  const [sortValue, setSort] = useState<any>(null);
  const [search, setSearch] = useState("");
  const defaultColumns: Array<ColumnType> = [
    {
      key: "id",
      title: "AY",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            <Typography>{row?.assessmentYear ? `${row?.assessmentYear}` : ""}</Typography>
          </Box>
        );
      },
    },
    {
      key: "minorDesc",
      title: "Type of Payment",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            <Typography>
              {row?.minorDesc ? `${row?.minorDesc} (${row?.minorHead})` : "-"}
            </Typography>
          </Box>
        );
      },
    },
    {
      key: "paymentTime",
      title: "Date of Payment",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Typography>
            {row?.paymentTime ? moment(row?.paymentTime).format("MMM DD, YYYY") : "-"}
          </Typography>
        );
      },
    },
    {
      key: "natureOfPayment",
      title: "Nature of Payment",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return <Typography>{row?.natureOfPayment ? row?.natureOfPayment : "-"}</Typography>;
      },
    },
    {
      key: "acin",
      title: (
        <Box display="flex" alignItems="center">
          <Typography>Alternate CIN</Typography>
          <Tooltip title="Alternate CIN has first 7 digits as BSR code of bank followed by date of payment in 8 digits and further followed by 5 digit challan number">
            <HelpOutlineIcon fontSize="small" sx={{ marginLeft: "5px" }} />
          </Tooltip>
        </Box>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },

    {
      key: "totalAmt",
      title: "Total Amount",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Tooltip
            title={`Tax: ${row?.basicTax} + Surcharge: ${row?.surCharge} + Cess: ${row?.eduCess
              } + Interest: ${row?.interest} + Penalty: ${row?.penalty} + Others: ${row?.others
              } = Total Amount: ${formatToRupeess(row?.totalAmt)}`}
          >
            <Typography>
              <Box display="flex" alignItems="center">
                <CurrencyRupeeIcon sx={{ width: "15px" }} /> {formatToRupeess(row?.totalAmt)}
              </Box>
            </Typography>
          </Tooltip>
        );
      },
    },
  ];
    const [sort, setSorting] = useState<any>({});
    const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const { data, isLoading }: ResType = useQuery(
    [
      "get-e-challan-tan",
      params.incometaxid,
      {
        limit: pageCount,
        offset: page * pageCount,
        search,
        sortValue,
        assessmentYear,
        sort
      },
    ],
    getTanClientEchallan,
    {
      onSuccess: (res) => {
        setCheckAccess(res?.data?.accessDenied);
        setTotalCount(res?.data?.count);
      },
    }
  );
  const { data: clientData, isLoading: isLoading1 }: ResType = useQuery(
    ["get-income-tax-tan-profile", params.incometaxid],
    getIncomeTaxProfile
  );
  const clientName = clientData?.data?.profileDetails?.name;
  const { mutate: mutate1 } = useMutation(exportTanClientChallan, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - ${clientName} Income Tax (TAN) Challans ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax (TAN) Challans exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const onSortChange = (e: any) => {
    setPage(0);
    setSort(e.target.value);
  };

  const handleSearch = (e: any) => {
    setPage(0);
    setSearch(e);
  };

  const onAssessmentYearChange = (e: any) => {
    setAssessmentYear(e.target.value);
    setPage(0);
  };

  const handleExport = () => {
    mutate1({
      ...state,
      incometaxid: params.incometaxid,
    });
  };
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSorting,
      setColumns: setColumns,
    });
  };
  function calculateAssessmentYear(startYear) {
    const endYear = parseInt(startYear) + 1;
    return startYear + "-" + endYear.toString().slice(2);
  }

  const handleRowClick = (v: any) => {
    navigate(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/e-challan/${v?.id}`);
  };

  if (isLoading) return <Loader />;
  return (
    <>
      {!checkAccess && <AccessDenied />}
      {checkAccess && (
        <Box pl={1} pr={1}>
          <Box display="flex" m={1}>
            <Box ml={1}>
              <TextField
                name="assessmentYear"
                value={assessmentYear}
                onChange={onAssessmentYearChange}
                size="small"
                label="Assessment Year"
                select
                sx={{ width: 150 }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                <MenuItem key={""} value={"null"}>
                  NA
                </MenuItem>
                {getAutFinancialYears().map((year: string) => (
                  <MenuItem key={year} value={year.split("-")[0]}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box ml={1}>
              <TextField
                name="sortValue"
                value={sortValue}
                onChange={onSortChange}
                size="small"
                label="Sort By"
                select
                sx={{ width: 100 }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                {sortFilter.map((sort) => (
                  <MenuItem key={sort.value} value={sort.value}>
                    {sort.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box ml={1}>
              <SearchContainer
                minWidth="300px"
                debounced
                value={search}
                placeHolder="Search by payment type | ACIN"
                onChange={handleSearch}
              />
            </Box>
            <Box ml={1}>
              <Button
                onClick={() => {
                  setAssessmentYear(null);
                  setSort(null);
                  setSearch("");
                  setInterval("");
                }}
                size="medium"
                color="secondary"
                variant="outlined"
                sx={{ marginRight: 2 }}
              >
                Clear Filters
              </Button>
            </Box>

            <Button
              variant="outlined"
              color="secondary"
              onClick={handleExport}
              startIcon={<FileDownloadOutlinedIcon />}
            >
              Export
            </Button>
          </Box>
          {data && data?.data.count > 0 ? (
            <>
              <Table
                sx={{ height: "460px" }}
                // selection={{ selected, setSelected }}
                pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
                data={data?.data?.result || []}
                columns={columns}
                 sortHandler={handleSort}
                loading={isLoading}
                onRowClick={handleRowClick}
              />
            </>
          ) : (
            <>
              <Box textAlign="center" mt={20}>
                <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">
                  No Data present
                </Typography>
              </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default TanClientChallan;
